import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_API_URL);

const createSocketMiddleware = () => {
	/**
	 * Data emitted from the server should be placed here.
	 * use storeAPI.dispatch to send the data into redux state
	 */
	// returns a room code on app request
	return storeAPI => {
		const tryReconnect = function () {
			if (!socket.connected) {
				socket.connect();
			}
		};

		let connectionInterval;

		// Handles socket connection event
		socket.on("connect", () => {
			clearInterval(connectionInterval);
			storeAPI.dispatch({
				type: "app/setConnectedToSocket",
				payload: { connectedToSocket: true },
			});
			const roomCode = localStorage.getItem("roomCode");
			const player = localStorage.getItem("player");
			if (roomCode) {
				socket.emit("joinRoom", { roomCode: roomCode });
				if (player) {
					socket.emit("getPlayer", { roomCode: roomCode, player: player });
				}
			}
		});

		// Handle socket disconnection event. Set a timer to reconnect
		socket.on("disconnect", () => {
			connectionInterval = setInterval(tryReconnect, 750);
			storeAPI.dispatch({
				type: "app/setConnectedToSocket",
				payload: { connectedToSocket: false },
			});
		});

		socket.on("clearGame", data => {
			localStorage.removeItem("roomCode");
			localStorage.removeItem("player");
			const roomCode = "";
			const player = {
				id: "",
				name: "",
				role: "",
			};
			storeAPI.dispatch({
				type: "game/setRoomCode",
				payload: {
					roomCode: roomCode,
				},
			});
			storeAPI.dispatch({
				type: "game/setPlayer",
				payload: {
					player: player,
				},
			});
		});

		// starts a game on player request
		socket.on("gameCreated", data => {
			localStorage.setItem("roomCode", data.roomCode);
			storeAPI.dispatch({
				type: "game/initGame",
				payload: data,
			});
		});

		// sets the validity of a player insertedroom code
		socket.on("setRoomCodeValid", data => {
			storeAPI.dispatch({
				type: "app/setRoomCodeValid",
				payload: data,
			});
		});

		// sets the validity of a player insertedroom code
		socket.on("setPlayerNameAvailable", data => {
			storeAPI.dispatch({
				type: "app/setPlayerNameAvailable",
				payload: data,
			});
		});

		// sets the player details when player joins a game
		socket.on("setPlayer", data => {
			localStorage.setItem("player", data.id);
			storeAPI.dispatch({
				type: "game/setPlayer",
				payload: data,
			});
		});

		// send the player to a game room
		socket.on("setRoomCode", data => {
			localStorage.setItem("roomCode", data.roomCode);
			storeAPI.dispatch({
				type: "app/clearError",
			});
			storeAPI.dispatch({
				type: "game/setRoomCode",
				payload: data,
			});
		});

		// used to update the game state
		socket.on("gameState", data => {
			storeAPI.dispatch({
				type: "game/setGameState",
				payload: data,
			});
		});

		// update the state of the main claim
		socket.on("setMainClaimState", data => {
			storeAPI.dispatch({
				type: "game/setMainClaimState",
				payload: data,
			});
		});

		// updates the main claim if edited
		socket.on("updateMainClaim", data => {
			storeAPI.dispatch({
				type: "game/updateMainClaim",
				payload: data,
			});
		});

		// changes the phase of the game
		socket.on("phaseChange", data => {
			storeAPI.dispatch({
				type: "game/changeGamePhase",
				payload: data,
			});
		});

		// adds a reason to play to the app state
		socket.on("addReasonToPlay", data => {
			storeAPI.dispatch({
				type: "game/addReasonToPlay",
				payload: data,
			});
		});

		// sends a reason-to-play that has been edited to the redux store
		socket.on("updateReasonToPlay", data => {
			storeAPI.dispatch({
				type: "game/updateReasonToPlay",
				payload: data,
			});
		});

		// sends a reason-to-play to be deleted from the store
		socket.on("deleteReasonToPlay", data => {
			storeAPI.dispatch({
				type: "game/deleteReasonToPlay",
				payload: data,
			});
		});

		// receives all game reasons to play
		socket.on("updateReasonsToPlay", data => {
			storeAPI.dispatch({
				type: "game/updateReasonsToPlay",
				payload: data,
			});
		});

		// recieves a reason in play to begin a bout of logical skirmish
		socket.on("moveToReasonInPlay", data => {
			storeAPI.dispatch({
				type: "game/moveToReasonInPlay",
				payload: data,
			});
		});

		// sends a reason-in-play that has been edited to the redux store
		socket.on("updateReasonInPlay", data => {
			storeAPI.dispatch({
				type: "game/updateReasonInPlay",
				payload: data,
			});
		});

		// update the ReasonInPlayVotes
		socket.on("updateReasonInPlayVotes", data => {
			storeAPI.dispatch({
				type: "game/updateReasonInPlayVotes",
				payload: data,
			});
		});

		// receives an updated common grounds and sends it to the redux store
		socket.on("updateCommonGrounds", data => {
			storeAPI.dispatch({
				type: "game/updateCommonGrounds",
				payload: data,
			});
		});

		// recieves the winners of the game and sends to redux store
		socket.on("setFinalResults", data => {
			storeAPI.dispatch({
				type: "game/setFinalResults",
				payload: data,
			});
		});

		// recieves an error message from the server
		socket.on("error", data => {
			storeAPI.dispatch({
				type: "app/setError",
				payload: data,
			});
		});

		/**
		 * Data to be set to the server should be placed here
		 * Check for the type of action to emit to the server
		 */
		return next => action => {
			// tells the server to start a new game
			if (action.type === "game/emitStartGame") {
				socket.emit("initGame", action.payload);
				return;
			}

			// checks with server to see if room code is valid
			if (action.type === "app/emitIsRoomCodeValid") {
				socket.emit("isRoomCodeValid", action.payload);
				return;
			}

			// checks with server to see if player name valid
			if (action.type === "app/emitIsPlayerNameAvailable") {
				socket.emit("isPlayerNameAvailable", action.payload);
				return;
			}

			// puts player in the desired room to join the game
			if (action.type === "game/emitJoinGame") {
				socket.emit("joinRoom", action.payload);
				return;
			}

			if (action.type === "game/emitVoteConvinced") {
				socket.emit("voteConvinced", action.payload);
				return;
			}

			if (action.type === "game/emitVoteNotPersuaded") {
				socket.emit("voteNotPersuaded", action.payload);
				return;
			}

			// updates the main claim of the game
			if (action.type === "game/emitUpdateMainClaim") {
				socket.emit("updateMainClaim", action.payload);
				return;
			}

			// change the phase of the game
			if (action.type === "game/emitChangeGamePhase") {
				socket.emit("changeGamePhase", action.payload);
			}

			// sending a user added reason to play to the server
			if (action.type === "game/emitAddReasonToPlay") {
				socket.emit("addReasonToPlay", action.payload);
			}

			// send a reason to begin a bout or reason in play
			if (action.type === "game/emitMoveToReasonInPlay") {
				socket.emit("moveToReasonInPlay", action.payload);
			}

			// send an edited reason-to-play to the server
			if (action.type === "game/emitUpdateReasonToPlay") {
				socket.emit("updateReasonToPlay", action.payload);
			}

			// send an edited reason-to-play to the server
			if (action.type === "game/emitUpdateReasonToPlayPriorities") {
				socket.emit("updateReasonToPlayPriorities", action.payload);
			}

			// delete a reason-to-play to the server
			if (action.type === "game/emitDeleteReasonToPlay") {
				socket.emit("deleteReasonToPlay", action.payload);
			}

			// send an edited reason-in-play to the server
			if (action.type === "game/emitUpdateReasonInPlay") {
				socket.emit("updateReasonInPlay", action.payload);
			}

			// vote/unvote established for a ReasonInPlay
			if (action.type === "game/emitVoteEstablishedReasonInPlay") {
				socket.emit("voteEstablishedReasonInPlay", action.payload);
			}

			// vote/unvote contested for a ReasonInPlay
			if (action.type === "game/emitVoteContestedReasonInPlay") {
				socket.emit("voteContestedReasonInPlay", action.payload);
			}

			// vote/unvote non-germane for a ReasonInPlay
			if (action.type === "game/emitVoteNonGermaneReasonInPlay") {
				socket.emit("voteNonGermaneReasonInPlay", action.payload);
			}

			// move the current reason in play to common grounds
			if (action.type === "game/emitMoveRIPToCommonGround") {
				socket.emit("moveRIPToCommonGround", action.payload);
			}

			// move the current reason in play to dissensus list
			if (action.type === "game/emitMoveRIPToDissensus") {
				socket.emit("moveRIPToDissensus", action.payload);
			}

			// send a request to the server updating the common ground priorities/order
			if (action.type === "game/emitUpdateCommonGroundPriorities") {
				socket.emit("updateCommonGroundPriorities", action.payload);
			}

			// move the current reason in play to common grounds
			if (action.type === "game/emitMoveCommonGroundToReasonInPlay") {
				socket.emit("moveCommonGroundToReasonInPlay", action.payload);
			}

			// request the server return a list of winners
			if (action.type === "game/emitGetFinalResults") {
				socket.emit("getFinalResults", action.payload);
			}

			// leave the game
			if (action.type === "game/emitExitGame") {
				socket.emit("exitGame", action.payload);
			}

			return next(action);
		};
	};
};

export default createSocketMiddleware;
